<template>
  <select
    class="border border-1 px-3 py-2 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150"
    v-bind:class="{ 'border-red-500': error, 'bg-gray-300': disabled }"
    v-model="localValue"
  >
    <option :value="null" v-bind:selected="localValue===null" >{{emptyLabel}}</option>
    <option
      v-for="(item, key) in data"
      :key="key"
      :value="item.value"
      :v-text="item.label"
    >
      {{ item.label }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'Select',
  props: {
    emptyLabel: {
      type: String,
      default: 'Empty',
    },
    value: {
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      default: [],
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/Form/Select.vue